









































import VueBase from '@/pages/vue-base'
import axios from 'axios'
import {apiV1AdminMessageTemplatePath, apiV1AdminMessageTemplatesPath} from '@/rails/routes'
import MessageTemplate, {IMessageTemplate} from '@/models/MessageTemplate'
import {Component, Emit} from 'vue-property-decorator'
import TemplateEdit from '@/components/admin/messages/TemplateEdit.vue'

@Component({
  components: {
    TemplateEdit
  }
})
export default class TemplateList extends VueBase {
  messageTemplates: Array<MessageTemplate> = []
  selectedTemplate = new MessageTemplate()
  edit = new MessageTemplate()
  showedUpdateTemplate = false

  @Emit()
  onDelete(): Array<MessageTemplate> {
    return this.messageTemplates
  }

  @Emit()
  onCancel(): void {}

  @Emit()
  onSelect(): MessageTemplate {
    return this.selectedTemplate
  }

  async mounted(): Promise<void> {
    await this.loadTemplate()
  }

  async deleteTemplate(id): Promise<void> {
    this.showConfirm({
      title: '削除', message: '選択した定型文を削除しますか？', onClosed: async (result) => {
        if (result) {
          try {
            await axios.delete(apiV1AdminMessageTemplatePath(id))
            this.showMessage('削除が完了しました')
            await this.loadTemplate()
            this.onDelete()
          } catch (e) {
            console.log(e)
          }
        }
      }
    })
  }

  selectTemplate(): void {
    this.onSelect()
    this.showMessage('定型文の読み込みが完了しました。')
  }

  async loadTemplate(): Promise<void> {
    const messageTemplates = await axios.get<Array<IMessageTemplate>>(apiV1AdminMessageTemplatesPath())
    this.messageTemplates = messageTemplates.data.map(m => new MessageTemplate(m))
  }

  startEdit(messageTemplate: MessageTemplate): void {
    this.edit = new MessageTemplate({id: messageTemplate.id, title: messageTemplate.title, content: messageTemplate.content})
    this.showedUpdateTemplate = true
  }

  onSave(): void {
    this.loadTemplate()
    this.selectedTemplate = new MessageTemplate()
    this.close()
  }

  close(): void {
    this.edit = new MessageTemplate()
    this.showedUpdateTemplate = false
  }

}
